import { Component, createRef } from 'react';
import styled from 'styled-components';
import { StyledRichTextContent } from '~/features/rich-text-editor';
import { apiGet } from '../../../common';

const getIdForImage = ($img) => {
  let id = $img.attr('id') || $img.parent().attr('id');
  if (!id) {
    const src = $img.attr('src');
    const match = src && src.match(/image\/file\/([^/]*)\//);
    id = match && match[1];
  }

  return id;
};

export default class DocumentObjectTextarea extends Component {
  constructor(props) {
    super(props);
    this.textAreaRef = createRef();
  }

  componentDidMount() {
    return this.renderImagesForTextArea();
  }

  render() {
    return (
      <StyledRichTextContent
        ref={this.textAreaRef}
        sanitizeOptions={{ allowSafeTags: true, allowedDangerousTags: ['iframe', 'style'] }}
      >
        {this.props.html}
      </StyledRichTextContent>
    );
  }

  //  This is for the old functionality for images that required an
  //  authenticated proxy for loading images.
  renderImagesForTextArea = () => {
    const el = $(this.textAreaRef.current);
    const images = el.find('img');
    images.each(function () {
      const img = $(this);
      const id = getIdForImage(img);
      if (id) {
        apiGet(
          `images/${id}`,
          null,
          (result) => {
            if (result && result.url) {
              img.attr('src', result.url);
            }
          },
          (err) => {
            // Do Nothing
          },
        );
      }
    });
  };
}
